import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'filter'
})

export class FilterPipe implements PipeTransform {
    transform(items: any[], filter : Record<string, string>): any {
      if (!items || !filter ) { 
        return items;
      }

      console.log("Filter Item:", items);
      const key = Object.keys(filter)[0];
      console.log("Key:",key);
      const value = filter[key];
      console.log("Value:",value);

      console.log (items.filter((e) => e[key].indexOf(value) !== -1));
      return items.filter((e) => e[key].indexOf(value) !== -1) 
    }
}